import {
    Box,
    FormControlLabel,
    InputLabel,
    Radio,
    RadioGroup,
} from "@material-ui/core";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import React from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isEmpty, isNotEmpty } from "../../Utils";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import { getFormId } from "../../redux/selector";

export function CheckBoxRadio(props) {
    return (
        <Radio
            checkedIcon={<CheckBoxIcon />}
            icon={<CheckBoxOutlineBlankIcon />}
            {...props}
        />
    );
}

export default function CustomRadioGroup({
    label = "",
    control,
    name,
    radioValue = "key",
    showError = true,
    required = true,
    onChange = () => {},
    options,
    isCheckBox = false,
    checkBoxIcon = false,
    row = true,
    inputProps = {},
    toolTip = null,
    disabled = false,
    displayColon = true,
    ...rest
}) {
    const { t } = useTranslation();
    const handleClick = (event, val, onChange) => {
        if (event.target.value === val) {
            onChange("");
        } else {
            onChange(event.target.value);
        }
    };

    const formId = useSelector(getFormId());

    return (
        <Controller
            control={control}
            name={name}
            render={({ field, fieldState }) => (
                <Box>
                    {!isEmpty(label) && (
                        <Box mb={4}>
                            <InputLabel
                                shrink
                                error={isNotEmpty(fieldState.error)}
                            >
                                <Box
                                    style={
                                        disabled
                                            ? { color: "rgba(0, 0, 0, 0.38)" }
                                            : {}
                                    }
                                >
                                    {label}
                                    {displayColon && t("common.colon")}
                                    {required && (
                                        <Box
                                            component="span"
                                            className="danger"
                                        >
                                            *
                                        </Box>
                                    )}
                                    {isNotEmpty(toolTip) ? toolTip : null}
                                </Box>
                            </InputLabel>
                        </Box>
                    )}
                    <RadioGroup
                        row={row}
                        aria-label={name}
                        value={field?.value}
                        onChange={(e) => {
                            onChange(e.target.value);
                            field.onChange(e.target.value);
                        }}
                        inputProps={{
                            "aria-labelledby": name,
                            ...inputProps,
                        }}
                        {...rest}
                    >
                        {Object.entries(options).map(([key, value]) => (
                            <FormControlLabel
                                key={key}
                                value={radioValue == "key" ? key : value}
                                control={
                                    checkBoxIcon ? (
                                        <CheckBoxRadio
                                            disabled={disabled}
                                            onClick={(e) =>
                                                isCheckBox == true
                                                    ? handleClick(
                                                          e,
                                                          key,
                                                          field.onChange
                                                      )
                                                    : ""
                                            }
                                        />
                                    ) : (
                                        <Radio
                                            color="primary"
                                            disabled={disabled}
                                            onClick={(e) =>
                                                isCheckBox == true ||
                                                formId === "Form001"
                                                    ? handleClick(
                                                          e,
                                                          key,
                                                          field.onChange
                                                      )
                                                    : ""
                                            }
                                        />
                                    )
                                }
                                label={value}
                            />
                        ))}
                    </RadioGroup>
                    {showError && (
                        <ErrorMsg message={fieldState?.error?.message} />
                    )}
                </Box>
            )}
        />
    );
}
